import React from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import Customers from "../components/Customers/Customers";
import DashBoard from "../components/DashBoard";
import AddEditEvents from "../components/Events/AddEditEvents";
import Events from "../components/Events/Events";
import Jobs from "../components/Jobs/Jobs";
import UserGroups from "../components/UserGroups/UserGroups";
import UserManagement from "../components/UserManagement/UserManagement";
import AddEditJobs from "../components/Jobs/AddEditJobs";
import WorkFlow from "../components/WorkFlow/Workflow";
import AddEditWorkFlow from "../components/WorkFlow/AddEditWorkFlow";
import NotFound from "../components/404/NotFound";
import PrepTeamQueue from "../components/PrepTeamQUeue/PrepTeamQueue";
import JobEventAdmin from "../components/Jobs/JobEventAdmin";
import HistoryTable from "../components/Jobs/HistoryTable";
import AddPreprocessing from "../components/PrepTeamQUeue/AddPreProcessing";
import JobDashBoard from "../components/Jobs/JobDashBoard";
import JobsEventsDetailsAdmin from "../components/Jobs/JobsEventsDetailsAdmin";
import UserUploadLogs from "../components/UploadLogs/UserUploadLogs";
import JobEventUploadLogs from "../components/UploadLogs/JobEventUploadLogs";
import JobEventCompleted from "../components/Jobs/JobEventCompleted";
import WeareHouse from "../components/WareHouse/WareHouse";
import AddWeareHouse from "../components/WareHouse/AddWareHouse";
import EventStagesHistory from "../components/Jobs/EventStagesHistory";
import AllBoxes from "../components/BoxProcessing/AllBoxes";
import BoxHistory from "../components/BoxProcessing/BoxHistory";
import ReportsData from "../components/Reports/Reports";
import Monetization from "../components/Reports/Monetization";
import BoxProgress from "../components/Reports/BoxProgress";
import JobInspection from "../components/Reports/JobInspection";
import EventBoxes from "../components/BoxProcessing/EventBoxes";
import ReviewAndAssignSpec from "../components/WareHouse/ReviewAndAssignSpec";
import UpdateDelivery from "../components/WareHouse/UpdateDelivery";
import Disposition from "../components/WareHouse/Dispositon";
import BoxDetails from "../components/WareHouse/BoxesDetails";
import StationMaster from "../components/Events/StationMaster";
const AdminRoutes = () => {
   return (
      <Routes>
         <Route path="/" element={<Outlet />}>
            <Route path="dashboard" element={<DashBoard />} />
            <Route path="user-group" element={<UserGroups />} />
            <Route path="user-management" element={<UserManagement />} />
            <Route path="customers" element={<Customers />} />
            <Route path="events" element={<Outlet />}>
               <Route index element={<Events />} />
               <Route path="add" element={<AddEditEvents />} />
               <Route path="edit/:event_id" element={<AddEditEvents />} />
               <Route path="station-master" element={<StationMaster />} />
            </Route>
            <Route path="jobs" element={<Outlet />}>
               <Route index element={<Jobs />} />
               <Route path="add" element={<AddEditJobs />} />
               <Route path="edit/:id" element={<AddEditJobs />} />
               <Route path="job_event_details/:id" element={<JobsEventsDetailsAdmin />} />
               <Route path="job_event/:id" element={<JobEventAdmin />} />
               <Route path="job_event_completed/:id" element={<JobEventCompleted />} />

               {/* <Route path="edit/:event_id" element={<AddEditEvents />} /> */}
            </Route>
            <Route path="/add-preprocess/:id" element={<AddPreprocessing />} />
            <Route path="workflow" element={<WorkFlow />} />
            <Route path="/workflow/add" element={<AddEditWorkFlow />} />
            <Route path="/workflow/edit/:workflow_id" element={<AddEditWorkFlow />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/prep-queue" element={<PrepTeamQueue />} />

            <Route path="/view-history/:id" element={<HistoryTable />} />
            <Route path="/job-dashboard/:id" element={<JobDashBoard />} />
            <Route path="/view-history/:id" element={<HistoryTable />} />
            <Route path="/upload-log" element={<UserUploadLogs />} />
            <Route path="/job-event-log" element={<JobEventUploadLogs />} />
            <Route path="/wearhouse/:all" element={<WeareHouse />} />
            <Route path="/add-wearehouse/:id" element={<AddWeareHouse />} />
            <Route path="/view-event-stages-history/:id" element={<EventStagesHistory />} />
            <Route path="/all-boxes" element={<AllBoxes />} />
            <Route path="/event-boxes/:id" element={<EventBoxes />} />
            <Route path="/box-history" element={<BoxHistory />} />
            <Route path="/reports" element={<ReportsData />} />
            <Route path="/monetization" element={<Monetization />} />
            <Route path="/box-progress" element={<BoxProgress />} />
            <Route path="/job-inspection" element={<JobInspection />} />
            <Route path="/review-and-assign-spec/:all" element={<ReviewAndAssignSpec />} />
            <Route path="/update-delivery" element={<UpdateDelivery />} />
            <Route path="/disposition" element={<Disposition />} />
            <Route path="/view-boxes" element={<BoxDetails />} />

         </Route>
      </Routes>
   );
};

export default AdminRoutes;
